if (!customElements.get('loyalty-points-pdp')) {
  class LoyaltyPointsPdp extends HTMLElement {
    connectedCallback() {
      this.pointsEl = this.querySelector('[data-loyalty-points]');
      this.productEl = this.closest('.js-product');

      if (this.productEl && this.pointsEl) {
        this.onVariantChange = this.handleVariantChange.bind(this);
        this.productEl.addEventListener('on:variant:change', this.onVariantChange);
      }
    }

    disconnectedCallback() {
      if (this.productEl && this.onVariantChange) {
        this.productEl.removeEventListener('on:variant:change', this.onVariantChange);
      }
    }

    handleVariantChange(evt) {
      const variant = evt.detail?.variant;
      if (!variant || !this.pointsEl) return;

      this.pointsEl.textContent = Math.floor(variant.price / 100);
    }
  }

  customElements.define('loyalty-points-pdp', LoyaltyPointsPdp);
}
